import { cn } from "@/lib/utils";

export type CustomPictogramProps = React.PropsWithoutRef<
  React.SVGProps<SVGSVGElement>
>;

export const Pictograms = {
  SportingGoods: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 1C7.72 1 1 7.72 1 16s6.72 15 15 15 15-6.72 15-15S24.28 1 16 1m-.62 28.72c-3.09-.14-5.92-1.29-8.16-3.15 2.86-2.63 4.68-6.38 4.68-10.57S10.09 8.05 7.22 5.43c2.23-1.86 5.06-3.01 8.16-3.15zm1.24-27.44c3.09.14 5.92 1.29 8.16 3.15C21.92 8.06 20.1 11.81 20.1 16s1.81 7.95 4.68 10.57a13.653 13.653 0 0 1-8.16 3.15zM2.25 16c0-3.79 1.55-7.23 4.04-9.73 2.67 2.4 4.36 5.86 4.36 9.73s-1.69 7.32-4.36 9.73A13.726 13.726 0 0 1 2.25 16m23.46 9.73c-2.67-2.4-4.36-5.86-4.36-9.73s1.69-7.32 4.36-9.73c2.49 2.49 4.04 5.93 4.04 9.73s-1.55 7.23-4.04 9.73"
      />
    </svg>
  ),
  None: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m27.03 5.86 3.41-3.41-.88-.88-3.41 3.41a14.921 14.921 0 0 0-10.14-3.97C7.72 1 1 7.72 1 16c0 3.92 1.51 7.47 3.97 10.14l-3.41 3.41.88.88 3.41-3.41c2.67 2.46 6.23 3.97 10.14 3.97 8.28 0 15-6.72 15-15 0-3.92-1.51-7.47-3.97-10.14ZM2.25 16C2.25 8.42 8.42 2.25 16 2.25c3.57 0 6.81 1.38 9.26 3.61l-19.4 19.4C3.63 22.81 2.25 19.57 2.25 16M16 29.75c-3.57 0-6.81-1.38-9.25-3.61L26.14 6.75c2.23 2.45 3.61 5.69 3.61 9.25 0 7.58-6.17 13.75-13.75 13.75"
      />
    </svg>
  ),
  NoEquityDilution: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 1C7.72 1 1 7.72 1 16s6.72 15 15 15 15-6.72 15-15S24.28 1 16 1m0 28.75C8.41 29.75 2.25 23.59 2.25 16S8.41 2.25 16 2.25 29.75 8.41 29.75 16 23.59 29.75 16 29.75M18 16c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2"
      />
    </svg>
  ),
  NoHiddenFees: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M26 15.65V1h-1.25v13.44A12.87 12.87 0 0 0 20 11.65V1h-1.25v10.31c-.91-.2-1.83-.31-2.75-.31s-1.84.11-2.75.31V1H12v10.65a12.87 12.87 0 0 0-4.75 2.79V1H6v14.65L.64 21.02l6.19 6.19c2.52 2.52 5.83 3.78 9.13 3.78s6.61-1.26 9.13-3.78l6.23-6.23L26 15.66Zm-1.79 10.67c-2.2 2.2-5.13 3.42-8.25 3.42s-6.05-1.21-8.25-3.42L2.4 21.01l5.35-5.35c2.2-2.2 5.13-3.42 8.25-3.42s6.05 1.21 8.25 3.42l5.31 5.31zM16 15c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6m0 10.75c-2.62 0-4.75-2.13-4.75-4.75s2.13-4.75 4.75-4.75 4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75"
      />
    </svg>
  ),
  ShorterTerms: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 1C7.72 1 1 7.72 1 16s6.72 15 15 15 15-6.72 15-15S24.28 1 16 1m0 28.75C8.42 29.75 2.25 23.58 2.25 16S8.42 2.25 16 2.25 29.75 8.42 29.75 16 23.58 29.75 16 29.75m.62-14.37H22v1.25h-6.62V5h1.25v10.38Z"
      />
    </svg>
  ),
  ToysGames: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M28.26 11H19V1.01h-5.99v10H3.74c-2.39 0-3.63 2.85-2.01 4.6L16 31.01l14.27-15.4c1.62-1.75.38-4.6-2.01-4.6Zm-14-8.74h3.49v8.75h-3.49zM16 29.16 7.51 20h16.97l-8.49 9.16Zm9.67-10.43H6.33l-2.52-2.72h24.38zm3.7-4.01H2.63c-.58-.65-.34-1.37-.25-1.58.09-.21.46-.89 1.36-.89h24.52c.9 0 1.27.68 1.36.89.09.21.33.92-.25 1.58"
      />
    </svg>
  ),
  Cake: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M28.94 11h-5.68V8h-1.25v3h-5.76V8H15v3H9.26V8H8.01v3H3.06C1.92 11 1 11.95 1 13.12v15.77c0 1.17.92 2.12 2.06 2.12h25.87c1.14 0 2.06-.95 2.06-2.12V13.12c0-1.17-.92-2.12-2.06-2.12Zm.81 17.88c0 .48-.36.87-.81.87H3.06c-.45 0-.81-.39-.81-.87v-5.71c1.69-.24 2.62-1.43 3.45-2.5.86-1.11 1.61-2.07 3.1-2.07s2.24.96 3.1 2.07c.93 1.2 1.98 2.56 4.09 2.56s3.16-1.36 4.09-2.56c.86-1.11 1.61-2.07 3.1-2.07s2.24.96 3.11 2.07c.83 1.07 1.77 2.26 3.46 2.5zm0-6.98c-1.09-.23-1.74-1.06-2.47-2-.93-1.2-1.99-2.55-4.09-2.55s-3.16 1.36-4.09 2.56c-.86 1.11-1.61 2.07-3.1 2.07s-2.24-.96-3.1-2.07c-.93-1.2-1.98-2.56-4.09-2.56s-3.16 1.36-4.09 2.56c-.73.94-1.38 1.77-2.46 2v-8.79c0-.48.36-.87.81-.87h25.87c.45 0 .81.39.81.87v8.79ZM22.63 6.83c1.2 0 2.18-.95 2.18-2.12S22.63 1 22.63 1s-2.18 2.55-2.18 3.71.97 2.12 2.18 2.12m0-3.79c.52.74.9 1.41.93 1.67 0 .48-.42.87-.93.87s-.93-.39-.93-.85c.03-.28.41-.95.93-1.69m-7.01 3.79c1.2 0 2.18-.95 2.18-2.12S15.62 1 15.62 1s-2.18 2.55-2.18 3.71.97 2.12 2.18 2.12m0-3.79c.52.74.9 1.41.93 1.67 0 .48-.42.87-.93.87s-.93-.39-.93-.85c.03-.28.41-.95.93-1.69M8.63 6.83c1.2 0 2.18-.95 2.18-2.12S8.63 1 8.63 1 6.45 3.55 6.45 4.71s.97 2.12 2.18 2.12m0-3.79c.52.74.9 1.41.93 1.67 0 .48-.42.87-.93.87s-.93-.39-.93-.85c.03-.28.41-.95.93-1.69"
      />
    </svg>
  ),
  Partnerships: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.39 10.61C21.08 5.26 16.64.99 11.21.99S.99 5.57.99 11.21s4.26 9.87 9.62 10.18c.31 5.36 4.75 9.62 10.18 9.62S31 26.43 31 20.8s-4.26-9.87-9.62-10.18Zm-.6 19.15c-4.74 0-8.62-3.7-8.93-8.37 4.22-.27 7.83-3.07 9.1-7.15l-1.19-.37a8.917 8.917 0 0 1-8.56 6.3c-4.94 0-8.96-4.02-8.96-8.96s4.01-8.97 8.96-8.97 8.62 3.7 8.93 8.37c-4.22.27-7.83 3.07-9.1 7.15l1.19.37a8.917 8.917 0 0 1 8.56-6.3c4.94 0 8.96 4.02 8.96 8.96s-4.02 8.96-8.96 8.96Z"
      />
    </svg>
  ),
  Health: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M23 9V1H9v8H1v14h8v8h14v-8h8V9zM9 21.75H2.25v-11.5H9zm12.75 8h-11.5V23h11.5zm0-8h-11.5v-11.5h11.5zm0-12.75h-11.5V2.25h11.5zm8 12.75H23v-11.5h6.75z"
      />
    </svg>
  ),
  Funding: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M1 1v13l7.27 2.06L1 18v13l30-8V10zm17.75 10.99c0 2.8-1.45 4.76-2.75 4.76s-2.75-1.95-2.75-4.76S14.7 7.23 16 7.23s2.75 1.95 2.75 4.76m-16.5 1.06V2.68l12.34 3.7C13.08 7.24 12 9.42 12 11.99c0 1.61.42 3.06 1.1 4.14zm0 16.32V18.96l8.37-2.23 18.93 5.36zm27.5-8.52-12.06-3.42c1.36-.96 2.31-3.03 2.31-5.44 0-1.72-.49-3.27-1.26-4.37l11.01 3.3v9.92Z"
      />
    </svg>
  ),
  CraftProduct: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M26 1H6L.49 12.5 16 31l15.5-18.5zm-.79 1.25 4.6 9.63h-7.45l-5.51-9.63zm-4.29 9.63h-9.84L16 3.29zM6.79 2.25h8.36l-5.51 9.63H2.18zM2.65 13.13h6.91l4.99 14.19zM16 27.69l-5.12-14.56h10.24zm1.45-.37 4.99-14.19h6.9z"
      />
    </svg>
  ),
  GlobalEconomy: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 1C7.72 1 1 7.72 1 16s6.72 15 15 15 15-6.72 15-15S24.28 1 16 1M8 4.83v8.92H2.45C3.06 10.09 5.11 6.91 8 4.83m8 24.92C8.42 29.75 2.25 23.58 2.25 16c0-.34.02-.67.05-1h5.91l5.04 13H18V13.75H9.25V4.04c1.99-1.13 4.29-1.79 6.75-1.79s4.95.72 7 1.94v15.8h6.15c-1.72 5.64-6.96 9.76-13.15 9.76M9.55 15h7.21v11.75h-2.65zm14.71 3.74V5.04c3.33 2.51 5.49 6.48 5.49 10.96 0 .94-.1 1.85-.28 2.74z"
      />
    </svg>
  ),
  MilestoneSequential1: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18 6h1.25v10H18zm7.7 4.56L30.99 21H6.07L2.33 31H.99L12.21 1h18.78l-5.3 9.56Zm-1.41-.03 4.59-8.28h-15.8l-6.55 17.5h22.42l-4.67-9.22Z"
      />
    </svg>
  ),
  Lock: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M23.25 15V8.59c0-4.18-3.42-7.58-7.62-7.58s-7.62 3.4-7.62 7.58V15H1v16h30V15zm-14-6.41c0-3.49 2.86-6.33 6.38-6.33s6.38 2.84 6.38 6.33V15H9.26V8.59Zm20.5 21.16H2.25v-13.5h27.5zM16.26 27h-1.25v-7h1.25z"
      />
    </svg>
  ),
  Country: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.57 16.95c-1.22-1.81-3.05-2.8-4.94-2.98V9h10.38V1H15.39v12.97c-1.89.18-3.73 1.17-4.94 2.98L1 31h30zm-4.95-14.7h9.13v5.5h-9.13zm-5.15 15.4c1.05-1.57 2.7-2.46 4.53-2.46s3.48.9 4.53 2.46l8.12 12.1H3.34l8.12-12.1Z"
      />
    </svg>
  ),
  BackingAcceleration: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 1v30h-1.25V1zM18 1l7 15-7 15h1.38l7-15-7-15zM2.95 1H1l18 15L1 31h1.95l18-15z"
      />
    </svg>
  ),
  HomeGarden: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 1 1 14.38V31h30V14.38zm-.62 28.75H2.25V15.63h13.12v14.12ZM2.88 14.38 16 2.67l6.41 5.72-6.69 5.98H2.88Zm22.5 15.37h-3.75v-7.12h3.75zm4.37 0h-3.12v-8.37h-6.25v8.37h-3.75V15.24l6.73-6.01 6.4 5.71v14.81Z"
      />
    </svg>
  ),
  ConnectCommPlatforms: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 27c7.18 0 13-5.82 13-13S21.18 1 14 1 1 6.82 1 14s5.82 13 13 13M2.25 14C2.25 7.52 7.52 2.25 14 2.25S25.75 7.52 25.75 14 20.48 25.75 14 25.75 2.25 20.48 2.25 14m18.37-3h-6.37V8H13v3H6.63l1.98 9h10l2.02-9ZM9.61 18.75l-1.43-6.5H13V15h1.25v-2.75h4.81l-1.46 6.5zM31 17.87v.1C31 25.17 25.17 31 17.97 31h-.1c-1.73 0-3.37-.34-4.87-.95v-1.37c1.49.68 3.14 1.07 4.87 1.07h.1c6.5 0 11.78-5.28 11.78-11.78v-.1c0-1.74-.39-3.39-1.07-4.87h1.37c.61 1.51.95 3.15.95 4.87"
      />
    </svg>
  ),
  Speed: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 13H21l8-12H9.5L1 14.25h10L5 31zM3.29 13l6.89-10.75h16.48l-8 12h8.33L7.49 27.76 12.78 13z"
      />
    </svg>
  ),
  Flexibility: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 13.75V15h-.45c-2.22 0-4.25-1.12-5.44-2.99l-3.67-5.78C20.26 4.36 18.22 3.25 16 3.25s-4.26 1.11-5.44 2.98l-3.67 5.78A6.417 6.417 0 0 1 1.45 15H1v-1.25h.45c1.79 0 3.43-.9 4.39-2.41l3.67-5.78C10.92 3.33 13.35 2 16.01 2s5.08 1.33 6.5 3.56l3.67 5.78c.96 1.51 2.6 2.41 4.39 2.41h.45Zm-5.89 6.24-3.67 5.78c-1.18 1.87-3.22 2.98-5.44 2.98s-4.26-1.11-5.44-2.98l-3.67-5.78A6.417 6.417 0 0 0 1.45 17H1v1.25h.45c1.79 0 3.43.9 4.39 2.41l3.67 5.78c1.41 2.23 3.84 3.56 6.5 3.56s5.08-1.33 6.5-3.56l3.67-5.78c.96-1.51 2.6-2.41 4.39-2.41h.45V17h-.45c-2.22 0-4.25 1.12-5.44 2.99Z"
      />
    </svg>
  ),
  BabyToddler: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31.48 12.24c-.39-1.18-1.4-1.97-2.64-2.05l-6.27-.39c-.66-.04-1.25-.47-1.49-1.08l-2.31-5.85C18.31 1.71 17.25.99 16.01.99s-2.3.72-2.76 1.88l-2.31 5.85A1.71 1.71 0 0 1 9.45 9.8l-6.27.39c-1.24.08-2.26.86-2.64 2.05-.38 1.19-.03 2.41.93 3.21l4.85 4c.51.42.74 1.11.57 1.75l-1.57 6.09c-.31 1.21.12 2.41 1.13 3.14.53.38 1.13.58 1.74.58.55 0 1.1-.16 1.6-.48l5.3-3.37a1.72 1.72 0 0 1 1.85 0l5.3 3.37c1.05.67 2.33.63 3.34-.1a2.912 2.912 0 0 0 1.13-3.14l-1.57-6.09c-.17-.64.06-1.33.57-1.75l4.85-4c.96-.79 1.32-2.02.93-3.21Zm-1.73 2.24-4.85 4c-.88.73-1.27 1.92-.98 3.03l1.57 6.09c.22.83-.2 1.49-.65 1.82-.46.33-1.21.52-1.93.06l-5.3-3.37c-.97-.62-2.22-.62-3.19 0l-5.3 3.37c-.73.46-1.48.27-1.93-.06a1.68 1.68 0 0 1-.65-1.82l1.57-6.09c.29-1.11-.1-2.3-.98-3.03l-4.85-4c-.67-.55-.72-1.32-.54-1.86.17-.54.67-1.13 1.53-1.19l6.27-.39c1.15-.07 2.16-.81 2.58-1.87l2.31-5.85c.32-.8 1.03-1.09 1.6-1.09s1.28.29 1.6 1.09l2.31 5.85c.42 1.07 1.43 1.8 2.58 1.87l6.27.39c.86.05 1.35.65 1.53 1.19.17.54.12 1.31-.54 1.86ZM20.38 14h1.25c0 3.1-2.52 5.62-5.62 5.62S10.39 17.1 10.39 14h1.25c0 2.41 1.96 4.38 4.38 4.38S20.4 16.42 20.4 14Z"
      />
    </svg>
  ),
  CalendarTimeline: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 3V1h-1.25v2h-9.5V1H10v2H1v28h30V3zm7.75 26.75H2.25V4.25H10V7h1.25V4.25h9.5V7H22V4.25h7.75zm-18.5-5h3V26H7v-1.25h3V12.31c-.71.74-1.73 1.31-3 1.31v-1.25c1.89 0 2.88-1.76 2.88-2.38h1.38v14.75Zm10.08-14.74c2.33 0 4.3 2 4.3 4.36 0 3.34-2.01 4.5-3.78 5.52-1.73 1-3.37 1.94-3.58 4.86h6.74V26H17v-.62c0-4.14 2.24-5.43 4.22-6.57 1.76-1.01 3.16-1.82 3.16-4.43 0-1.68-1.4-3.11-3.05-3.11s-3.01 1.35-3.01 3.01h-1.25c0-2.35 1.91-4.26 4.26-4.26Z"
      />
    </svg>
  ),
  Information: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 1C7.72 1 1 7.72 1 16s6.72 15 15 15 15-6.72 15-15S24.28 1 16 1m0 28.75C8.42 29.75 2.25 23.58 2.25 16S8.42 2.25 16 2.25 29.75 8.42 29.75 16 23.58 29.75 16 29.75M9 8h14v1.25h-6.38v13.5H23V24H9v-1.25h6.38V9.25H9z"
      />
    </svg>
  ),
  FoodBeverage: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 2.25V1H20.29l-1.92 4.09C17.59 5.03 16.8 5 15.99 5 7.72 5 1 8.02 1 11.75v19.24h30V11.76c0-3.15-4.81-5.79-11.3-6.54l1.39-2.96H31ZM16 6.27c.62 0 1.21.02 1.8.05l-5.04 10.76c-6.31-.64-10.49-3.09-10.51-5.32.02-2.6 5.66-5.49 13.75-5.49M2.25 29.75v-15.3c1.82 1.88 5.48 3.3 9.95 3.83L6.83 29.73l.03.02zm27.5 0H8.21l5.31-11.34c.81.06 1.63.1 2.48.1 6.15 0 11.44-1.67 13.75-4.06zm0-17.98c0 1.26-1.34 2.58-3.65 3.62-2.68 1.2-6.26 1.87-10.09 1.87-.66 0-1.29-.03-1.91-.06l5.04-10.77c6.37.63 10.6 3.09 10.61 5.34"
      />
    </svg>
  ),
  AnimalsPetSupplies: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M23 9H9L1 1v30h30V1zm6.75 20.75H2.25V4.02l5.87 5.87.37.37h15.04l.37-.37 5.87-5.87v25.73Zm-13.1-9.51L20 16h-8l3.36 4.15c-.08 2.34-2 4.23-4.36 4.23S6.62 22.42 6.62 20H5.37c0 3.1 2.52 5.62 5.62 5.62 2.18 0 4.07-1.25 5-3.06a5.626 5.626 0 0 0 5 3.06c3.1 0 5.62-2.52 5.62-5.62h-1.25c0 2.41-1.96 4.38-4.38 4.38s-4.22-1.84-4.35-4.13Zm.77-2.99L16.04 19l-1.42-1.75z"
      />
    </svg>
  ),
  ApparelAccessories: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 1h-7.21c-.94 3.42-4.07 5.94-7.79 5.94S9.15 4.42 8.21 1H1v11h8.57L1 31h30l-8.57-19H31zM2.94 29.75 6.44 22h19.14l3.5 7.75zm26.81-19h-9.26l.8 1.76 3.72 8.24H7l3.72-8.24.8-1.76H2.25v-8.5h5.06C8.69 5.79 12.14 8.19 16 8.19s7.31-2.4 8.69-5.94h5.06z"
      />
    </svg>
  ),
  BestPrices: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 7.7V1H1v6.7c2.97 1.58 5 4.7 5 8.3s-2.03 6.73-5 8.3V31h30v-6.7c-2.97-1.58-5-4.7-5-8.3s2.03-6.73 5-8.3M24.75 16c0 3.69 1.9 7.08 5 9.03v4.72H2.25v-4.72c3.1-1.94 5-5.33 5-9.03s-1.9-7.08-5-9.03V2.25h27.5v4.72c-3.1 1.94-5 5.33-5 9.03m-3.19 3.68.88.88L16 27l-6.44-6.44.88-.88 4.93 4.93V6h1.25v18.61l4.93-4.93Z"
      />
    </svg>
  ),
  Ecommerce: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 11V1H10.01v10H1l5.36 20h19.29l5.36-20h-9ZM11.26 2.25h9.49V11h-9.49zm13.42 27.5H7.32l-4.69-17.5h7.38V21h1.25v-8.75h9.49V21H22v-8.75h7.37z"
      />
    </svg>
  ),
  Simplicity: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path fill="currentColor" d="M29.75 2.25v27.5H2.25V2.25zM31 1H1v30h30z" />
    </svg>
  ),
  Beauty: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.75 1H15v11c0 .41-.29.74-.69.82-.43.08-.85-.13-.94-.34l-2.65-7.24c-.71-1.78-2.29-2.88-4.1-2.99H2.25v12.54c.11 2.42 2.06 4.33 4.45 4.33h3.86c.39 0 .71.27.78.65s-.13.75-.5.89l-8.61 3.27v5.82h6.69l4.81-6.63V16h1.25v15h-1.25v-5.82L9.53 31H1v-7.93l7.1-2.69H6.7c-3.06 0-5.57-2.44-5.7-5.56V1h5.67c2.32.14 4.33 1.55 5.15 3.61l1.94 5.46V1ZM25.3 20.38c3.06 0 5.57-2.44 5.7-5.56V1h-5.67c-2.32.14-4.33 1.55-5.15 3.61l-1.94 5.46V1h-1.25v11c0 .41.29.74.69.82.43.08.85-.13 1.01-.51l2.65-7.24c.64-1.61 2.22-2.71 4.03-2.82h4.38v12.54c-.11 2.42-2.06 4.33-4.45 4.33h-3.86c-.39 0-.71.27-.78.65s.13.75.5.89l8.61 3.27v5.82h-6.69l-4.81-6.63V16h-1.25v15h1.25v-5.82l4.2 5.82h8.56v-7.93l-7.1-2.69h1.4Z"
      />
    </svg>
  ),
  ReceiveFunds: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m17.75.6-.95.81 11.85 13.97H16.98C16.8 7.39 13.3 1 9 1S1 7.72 1 16s3.58 15 8 15 7.81-6.38 7.98-14.37h11.67L16.8 30.6l.95.81 13.07-15.4zM9 29.75c-3.56 0-6.57-5.95-6.73-13.12h13.47c-.17 7.18-3.18 13.12-6.73 13.12ZM2.27 15.38C2.44 8.2 5.45 2.25 9 2.25s6.57 5.95 6.73 13.13z"
      />
    </svg>
  ),
  Verify: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m20.61 29.81-.54 1.13c-7.07-3.35-8.13-8.17-8.13-10.75 0-2.34 1.82-4.24 4.05-4.24s3.96 1.8 4.05 4.05c0 1.73 1.41 3.13 3.13 3.13S26.3 21.72 26.3 20c0-5.69-4.63-10.32-10.32-10.32S5.66 14.31 5.66 20c0 1.99.57 3.92 1.64 5.58l-1.05.68c-1.2-1.87-1.84-4.03-1.84-6.26 0-6.38 5.19-11.57 11.57-11.57S27.55 13.62 27.55 20c0 2.42-1.97 4.38-4.38 4.38s-4.26-1.87-4.36-4.2c0-1.65-1.28-2.99-2.82-2.99s-2.8 1.34-2.8 2.99c0 2.79 1.29 6.72 7.41 9.62ZM9.43 20.45v-.44c0-3.62 2.95-6.56 6.57-6.56s6.56 2.94 6.56 6.56h1.25c0-4.31-3.5-7.81-7.81-7.81s-7.81 3.5-7.81 7.81v.41c-.04 1.79-.11 5.12 3.66 8.46l.83-.94c-3.34-2.96-3.28-5.8-3.24-7.5Zm15.3-15.9.62-1.09C19.64.24 12.36.24 6.66 3.46l.62 1.09c5.32-3.01 12.13-3.01 17.45 0M16 6.04c4.89 0 9.5 2.63 12.01 6.86l1.07-.64C26.34 7.65 21.33 4.79 16 4.79S5.65 7.65 2.92 12.25l1.07.64C6.5 8.66 11.1 6.03 16 6.03Zm7.18 20.51c-3.6 0-6.54-2.93-6.54-6.54h-1.25c0 4.29 3.49 7.79 7.79 7.79 2.22 0 4.35-.96 5.83-2.63l-.94-.83a6.556 6.556 0 0 1-4.89 2.21"
      />
    </svg>
  ),
  DataDriven: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 1v30h-1.25l.02-28.75H1V1zM1 9.25h21.77L22.75 31H24V8H1zm0 7h14.77L15.75 31H17V15H1zm0 7h7.77L8.75 31H10v-9H1z"
      />
    </svg>
  ),
  ConnectBankAccounts: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M22 9H6v10h16zm-9.94 8.75H7.25v-7.5h4.81c-.62.92-1.02 2.25-1.02 3.75s.4 2.83 1.02 3.75m1.94 0c-.68 0-1.71-1.5-1.71-3.75s1.03-3.75 1.71-3.75 1.71 1.5 1.71 3.75-1.03 3.75-1.71 3.75m6.75 0h-4.81c.62-.92 1.02-2.25 1.02-3.75s-.4-2.83-1.02-3.75h4.81zM14 27c7.18 0 13-5.82 13-13S21.18 1 14 1 1 6.82 1 14s5.82 13 13 13M2.25 14C2.25 7.52 7.52 2.25 14 2.25S25.75 7.52 25.75 14 20.48 25.75 14 25.75 2.25 20.48 2.25 14M31 17.87v.1C31 25.17 25.17 31 17.97 31h-.1c-1.73 0-3.37-.34-4.87-.95v-1.37c1.49.68 3.14 1.07 4.87 1.07h.1c6.5 0 11.78-5.28 11.78-11.78v-.1c0-1.74-.39-3.39-1.07-4.87h1.37c.61 1.51.95 3.15.95 4.87"
      />
    </svg>
  ),
  Revenue: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m1 12.12 9.87-9.87H1V1h12v12h-1.25V3.14L1.89 13l-.88-.88Zm18 8.13h9.87L19 30.12l.88.88 9.87-9.87v9.86H31v-12H19v1.25ZM19.01 1v1.25h9.87L1 30.12l.88.88L29.75 3.14v9.85H31V1z"
      />
    </svg>
  ),
  PercentOfRevenue: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13 1H1v12h12zm-1.25 10.75h-9.5v-9.5h9.5zm18.69-9.31-28 28-.88-.88 28-28zM19 19v12h12V19zm10.75 10.75h-9.5v-9.5h9.5z"
      />
    </svg>
  ),
  ConnectMarketingAnalytics: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 27c7.18 0 13-5.82 13-13S21.18 1 14 1 1 6.82 1 14s5.82 13 13 13M2.25 14C2.25 7.52 7.52 2.25 14 2.25S25.75 7.52 25.75 14 20.48 25.75 14 25.75 2.25 20.48 2.25 14m6.13 1.2h1.25V20H8.38zm3-2.4h1.25V20h-1.25zm4.24 7.2h-1.25v-9.6h1.25zm3 0h-1.25V8h1.25zM31 17.87v.1C31 25.17 25.17 31 17.97 31h-.1c-1.73 0-3.37-.34-4.87-.95v-1.37c1.49.68 3.14 1.07 4.87 1.07h.1c6.5 0 11.78-5.28 11.78-11.78v-.1c0-1.74-.39-3.39-1.07-4.87h1.37c.61 1.51.95 3.15.95 4.87"
      />
    </svg>
  ),
  LinkAccounts: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 9V1h-8v7.12l-7 7-7-7V1H1v8h7.12l7 7-7 7H1v8h8v-7.12l7-7 7 7V31h8v-8h-7.12l-7-7 7-7zm-6.75-6.75h5.5v5.5h-5.5zm-16.5 5.5h-5.5v-5.5h5.5zm0 22h-5.5v-5.5h5.5zm16.5-5.5h5.5v5.5h-5.5z"
      />
    </svg>
  ),
  Unlock: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.25 15V8.59c0-3.49 2.86-6.33 6.38-6.33s6.38 2.84 6.38 6.33V9h1.25v-.41c0-4.18-3.42-7.58-7.62-7.58s-7.62 3.4-7.62 7.58V15H1v16h30V15zm20.5 14.75H2.25v-13.5h27.5zM16.26 27h-1.25v-7h1.25z"
      />
    </svg>
  ),
  Electronics: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M1 1v30h30V1zm5.25 1.25H16V10c-1.65 0-3.15.67-4.23 1.75h-2.5c-1.75 0-3.02-1.16-3.02-2.75zM20.75 16c0 2.62-2.13 4.75-4.75 4.75s-4.75-2.13-4.75-4.75 2.13-4.75 4.75-4.75 4.75 2.13 4.75 4.75M2.25 2.25H5v6.74c0 2.28 1.83 4 4.27 4h1.54a5.968 5.968 0 0 0 1.54 7.75H2.25zm9.5 27.5h-9.5V22H16c1.94 0 3.66-.92 4.75-2.35v2.36c0 1.51-1.23 2.74-2.74 2.74h-6.26zm14 0H13V26h5.01c2.19 0 3.98-1.79 3.99-3.99v-5.76h3.74v13.5Zm4 0H27V15h-5v-5c0-1.75 1.16-3 2.76-3h4.99zm0-24h-4.99c-2.28 0-4 1.84-4 4.27v2.32a5.959 5.959 0 0 0-3.5-2.21V2.25h12.5v3.5Z"
      />
    </svg>
  ),
  Upload: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m16 6.12 8.44 8.44-.88.88-6.93-6.93V26h-1.25V8.51l-6.93 6.93-.88-.88zM31 16c0 8.28-6.72 15-15 15S1 24.28 1 16 7.72 1 16 1s15 6.72 15 15m-1.25 0c0-7.58-6.17-13.75-13.75-13.75S2.25 8.42 2.25 16 8.42 29.75 16 29.75 29.75 23.58 29.75 16"
      />
    </svg>
  ),
  Milestone: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 1H12.22L1 31h1.33l3.74-10H31l-5.29-10.44zm-2.04 18.75H6.54l6.54-17.5h15.8l-4.59 8.28z"
      />
    </svg>
  ),
  FirstPartyData: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M26.98 9.19C25.08 4.39 20.41 1 14.94 1c-2.33 0-4.8.61-7.26 2a9.628 9.628 0 0 0-3.67 3.66C.72 12.5 1.75 18.41 5.07 22.31l.03.03a5.589 5.589 0 0 1 .15 7.06L4 31h16v-4h4.04c1.08 0 1.96-.88 1.96-1.96V20h4zm-2.23 9.56v6.29c0 .39-.32.71-.71.71h-5.29v4H6.54c1.67-2.51 1.49-5.89-.52-8.25-3.32-3.91-3.67-9.36-.92-14.23a8.33 8.33 0 0 1 3.19-3.18c2.17-1.22 4.41-1.84 6.65-1.84 4.81 0 9.06 2.88 10.85 7.34l2.56 9.16z"
      />
    </svg>
  ),
  SignalsInsights: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="m20.24 25.2-.45-1.17c3.01-1.42 5.11-4.48 5.11-8.03s-2.09-6.61-5.11-8.03l.45-1.17c3.48 1.61 5.9 5.12 5.9 9.2s-2.42 7.6-5.9 9.2M7.11 16c0-3.55 2.09-6.61 5.11-8.03l-.45-1.17c-3.48 1.61-5.9 5.12-5.9 9.2s2.42 7.6 5.9 9.2l.45-1.17C9.21 22.61 7.11 19.55 7.11 16M21.99 2.27l-.46 1.17c4.82 2.13 8.19 6.95 8.19 12.55s-3.37 10.42-8.19 12.55l.46 1.17c5.29-2.31 8.99-7.58 8.99-13.73s-3.7-11.41-8.99-13.73ZM2.27 16c0-5.6 3.37-10.42 8.19-12.55L10 2.28C4.72 4.59 1.02 9.86 1.02 16s3.7 11.41 8.99 13.73l.46-1.17c-4.82-2.13-8.19-6.95-8.19-12.55Zm16.09-4.38-.46 1.17c1.1.65 1.84 1.84 1.84 3.21s-.75 2.56-1.84 3.21l.46 1.17C19.92 19.53 21 17.9 21 16s-1.07-3.54-2.64-4.38M12.25 16c0-1.37.75-2.56 1.84-3.21l-.46-1.17c-1.56.85-2.64 2.48-2.64 4.38s1.07 3.54 2.64 4.38l.46-1.17A3.722 3.722 0 0 1 12.25 16"
      />
    </svg>
  ),
  TailoredTerms: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.49 18c-2.82 0-5.22 1.8-6.11 4.32l-1.73-5.75L21.34 1h-1.31l-4.04 13.4L11.95 1h-1.31l4.69 15.57-1.73 5.75A6.492 6.492 0 0 0 7.49 18C3.91 18 1 20.91 1 24.49s2.91 6.49 6.49 6.49c2.8 0 5.18-1.78 6.09-4.26.09-.24.16-.48.22-.73l2.19-7.25 2.19 7.25c.06.25.13.49.22.72.91 2.48 3.29 4.26 6.09 4.26 3.58 0 6.49-2.91 6.49-6.49s-2.91-6.49-6.49-6.49ZM7.5 29.73c-2.89 0-5.24-2.35-5.24-5.24s2.35-5.24 5.24-5.24 5.24 2.35 5.24 5.24-2.35 5.24-5.24 5.24m16.99 0c-2.89 0-5.24-2.35-5.24-5.24s2.35-5.24 5.24-5.24 5.24 2.35 5.24 5.24-2.35 5.24-5.24 5.24"
      />
    </svg>
  ),
  MinimizeRisk: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.89 1C13.75 1 8.75 5.97 8.75 12.11v5.56L6.2 14.45a3.078 3.078 0 0 0-4.26-.54 3.086 3.086 0 0 0-.91 3.84l6.63 13.26h23.33v-18.9C30.99 5.97 26.02 1 19.88 1Zm9.86 28.75H8.44L6.56 26h23.19zm0-5H5.97v.07l-3.82-7.64c-.4-.79-.17-1.75.54-2.28a1.836 1.836 0 0 1 2.53.31l2.55 3.22L10 21.25V12.1c0-5.44 4.44-9.86 9.89-9.86s9.86 4.42 9.86 9.86v12.64Z"
      />
    </svg>
  ),
  LongTerm: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M30.69 16.6c-.39-3.31-3.33-5.83-6.83-5.85h-2.68c.98-1.42 1.32-3.19.91-4.96a6.186 6.186 0 0 0-4.62-4.61c-1.91-.44-3.87 0-5.36 1.2a6.233 6.233 0 0 0-2.36 4.89c0 1.25.39 2.47 1.08 3.49H8.15c-3.51.02-6.44 2.53-6.83 5.85-.22 1.91.37 3.81 1.64 5.22a6.553 6.553 0 0 0 4.87 2.18h7.54v7h1.25v-7h7.54c1.86 0 3.63-.79 4.88-2.18a6.609 6.609 0 0 0 1.64-5.22Zm-2.58 4.39c-1.02 1.14-2.49 1.74-4.01 1.76h-6.85l6.93-6.06-.82-.94-6.74 5.9V5h-1.25v16.64l-6.74-5.9-.82.94 6.93 6.06H7.89c-1.51.04-2.99-.63-4.01-1.76-1.03-1.14-1.51-2.69-1.33-4.24.32-2.69 2.72-4.73 5.6-4.75h5.67l-1.2-1.08A4.956 4.956 0 0 1 11 7.26c0-1.53.69-2.96 1.89-3.92s2.77-1.3 4.31-.95c1.81.41 3.26 1.86 3.68 3.68.42 1.81-.13 3.62-1.48 4.84L18.2 12h5.67c2.88.02 5.28 2.06 5.6 4.75.18 1.55-.3 3.09-1.33 4.24Z"
      />
    </svg>
  ),
  NoCollateralUnsecured: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 1C9.37 1 4 6.37 4 13c0 3.67 1.65 6.8 4.24 9L13 25.99V31h6v-5.01L23.76 22c2.59-2.2 4.24-5.33 4.24-9 0-6.63-5.37-12-12-12m0 1.25c2.07 0 3.99.6 5.63 1.61L16.8 19.75h-1.61L10.37 3.86A10.72 10.72 0 0 1 16 2.25m-8.23 17.5C6.14 17.84 5.25 15.51 5.25 13c0-3.39 1.58-6.41 4.04-8.39l4.6 15.14zm9.98 10h-3.5v-3.5h3.5zm5.21-8.71L18.24 25h-4.47l-4.71-3.95-.05-.05h14l-.04.04Zm1.27-1.29h-6.12l4.6-15.14c2.46 1.97 4.04 5 4.04 8.39 0 2.51-.89 4.85-2.52 6.75"
      />
    </svg>
  ),
  OneSimpleFee: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M31 29.75V31H1v-1.25h16V7.68c-2.53 6.48-8.66 10.94-16 10.94v-1.25c8.97 0 16-7.19 16-16.38h1.25v28.75H31Z"
      />
    </svg>
  ),
  WorkingCapital: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.12 13.63h-1.25V1h8.25v6.12h-1.25V2.25h-5.75v11.37Zm3.61-1.37 9.85-5.69 2.88 4.98-4.22 2.44.62 1.08 5.3-3.06-4.13-7.14-10.93 6.31.62 1.08Zm-4.33 4.98-9.85-5.69 2.88-4.98 4.22 2.44.62-1.08-5.3-3.06-4.13 7.14 10.93 6.31.62-1.08Zm2.87 2.5-9.85 5.69-2.88-4.98 4.22-2.44-.62-1.08-5.3 3.06 4.12 7.14 10.93-6.31zm4.33-4.98 9.85 5.69-2.88 4.98-4.22-2.44-.62 1.08 5.3 3.06 4.13-7.14-10.93-6.31-.62 1.08Zm-.72 14.99h-5.75v-4.88h-1.25v6.12h8.25V18.37h-1.25z"
      />
    </svg>
  ),
  CreateAccount: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M1 1v26.59C1 29.72 2.71 31 4.44 31c1.12 0 2.25-.54 2.92-1.73l4.99-8.81c.8-1.42 2.22-2.13 3.65-2.13s2.84.71 3.65 2.13l4.99 8.81c.68 1.2 1.8 1.73 2.92 1.73 1.73 0 3.44-1.29 3.44-3.41V1zm28.75 26.59c0 1.41-1.13 2.16-2.19 2.16-.45 0-1.29-.14-1.84-1.1l-4.99-8.81c-.98-1.73-2.75-2.76-4.73-2.76s-3.76 1.03-4.73 2.76l-4.99 8.81c-.54.96-1.38 1.1-1.84 1.1-1.06 0-2.19-.76-2.19-2.16V2.25h27.5zM16 15c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5m0-8.75c2.07 0 3.75 1.68 3.75 3.75s-1.68 3.75-3.75 3.75-3.75-1.68-3.75-3.75S13.93 6.25 16 6.25"
      />
    </svg>
  ),
  MilestoneSequential2: (props: CustomPictogramProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={cn("stroke-icon-primary size-8 stroke-0", props.className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 6h1.25v10H16zm3.75 10H21V6h-1.25zm5.95-5.44L30.99 21H6.07L2.33 31H.99L12.21 1h18.78l-5.3 9.56Zm-1.41-.03 4.59-8.28h-15.8l-6.55 17.5h22.42l-4.67-9.22Z"
      />
    </svg>
  ),
} as const;
